export const currencyMask = (value: string | number) => {
  let formattedValue = value.toString()
  formattedValue = formattedValue.replace(/\D/g, '')
  formattedValue = formattedValue.replace(/(\d)(\d{2})$/, '$1,$2')
  formattedValue = formattedValue.replace(/(?=(\d{3})+(\D))\B/g, '.')

  return formattedValue
}